var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardincometoliabilityratio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2441 15.274L27.2301 5.95105H5.63527L0.621216 15.274L2.56247 16.3179L6.29389 9.37977L10.0253 16.3179L11.9666 15.274L8.1379 8.15513H24.7274L20.8988 15.274L22.84 16.3179L26.5714 9.37977L30.3029 16.3179L32.2441 15.274Z",
    fill: "#FBB500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5061 0C15.4105 0 14.5225 0.888117 14.5225 1.98366V34.0897H18.4898V1.98366C18.4898 0.888117 17.6017 0 16.5061 0Z",
    fill: "#FFCE47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5061 0C15.4105 0 14.5225 0.888117 14.5225 1.98366V34.0897H16.5061V0Z",
    fill: "#FFE29E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45074 34.0897H25.5615V31.1841C25.5615 29.6239 24.2967 28.3591 22.7365 28.3591H10.2758C8.7156 28.3591 7.45081 29.6239 7.45081 31.1841L7.45074 34.0897Z",
    fill: "#FBB500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5061 28.3591H10.2757C8.71559 28.3591 7.45081 29.6239 7.45081 31.1841V34.0897H16.5062L16.5061 28.3591Z",
    fill: "#FFCE47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8013 32.1794H5.21094V35.9999H27.8013V32.1794Z",
    fill: "#FFCE47"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5061 32.1796H5.21094V36H16.5061V32.1796Z",
    fill: "#FFE29E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29388 20.6204C9.76985 20.6204 12.5878 17.8026 12.5878 14.3265H0C0 17.8025 2.81791 20.6204 6.29388 20.6204Z",
    fill: "#FFCE47"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29388 14.3265H0C0 17.8025 2.81784 20.6204 6.29388 20.6204V14.3265Z",
    fill: "#FFE29E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5714 20.6204C30.0474 20.6204 32.8653 17.8026 32.8653 14.3265H20.2775C20.2775 17.8025 23.0954 20.6204 26.5714 20.6204Z",
    fill: "#FFCE47"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5714 14.3265H20.2775C20.2775 17.8025 23.0954 20.6204 26.5714 20.6204V14.3265Z",
    fill: "#FFE29E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardincometoliabilityratio);
export default __webpack_public_path__ + "static/media/dashboardincometoliabilityratio.e21702a0b6d10b7a2eef05980485bbee.svg";
export { ForwardRef as ReactComponent };